import { getInvalidMessageI18n, getRequiredI18n } from "utils";
import * as Yup from "yup";

const requireDate = (messageI18n = "") => {
  return Yup.date()
    .typeError(getRequiredI18n(messageI18n))
    .required(getRequiredI18n(messageI18n));
};

const notRequireDate = () => {
  return Yup.date().notRequired().typeError("");
};

const requireNumber = (messageI18n = "") => {
  return Yup.number()
    .typeError(getRequiredI18n(messageI18n))
    .required(getRequiredI18n(messageI18n));
};

const notRequireNumber = () => {
  return Yup.number()
    .transform((e) => {
      if (!e) return undefined;
      return e as never;
    })
    .nullable()
    .notRequired();
};

const requireString = (messageI18n = "") => {
  return Yup.string().required(getRequiredI18n(messageI18n));
};

const notRequireString = () => {
  return Yup.string().notRequired();
};

const requireObject = (messageI18n = "") => {
  return Yup.object({
    label: Yup.string().required(getRequiredI18n(messageI18n)),
    value: Yup.string().required(getRequiredI18n(messageI18n)),
    original: Yup.object().notRequired(),
  }).required(getRequiredI18n(messageI18n));
};

const notRequireObject = () => {
  return Yup.object({
    label: Yup.string().notRequired(),
    value: Yup.string().notRequired(),
  }).notRequired();
};

const requireArrayObject = (messageI18n = "") => {
  return Yup.array()
    .of(
      Yup.object({
        label: Yup.string().required(getRequiredI18n(messageI18n)),
        value: Yup.string().required(getRequiredI18n(messageI18n)),
      })
    )
    .min(1, getRequiredI18n(messageI18n))
    .required(getRequiredI18n(messageI18n));
};

const notRequireArrayObject = () => {
  return Yup.array()
    .of(
      Yup.object({
        label: Yup.string().notRequired(),
        value: Yup.string().notRequired(),
      })
    )
    .notRequired();
};

const requireEmail = (messageI18n = "") => {
  return Yup.string()
    .email(getInvalidMessageI18n(messageI18n))
    .required(getRequiredI18n(messageI18n));
};

const notRequireEmail = () =>
  Yup.string()
    .email(getInvalidMessageI18n(getInvalidMessageI18n("email")))
    .notRequired();

const requiredBoolean = () => {
  return Yup.boolean().required();
};

const requiredDateRange = (messageI18n = "") => {
  return Yup.array(
    Yup.date()
      .required(getRequiredI18n(messageI18n))
      .typeError(getRequiredI18n(messageI18n))
  ).required();
};

const notRequireDateRange = () => {
  return Yup.array(Yup.date().notRequired()).notRequired();
};

const requireCode = (messageI18n = "") => {
  return Yup.string()
    .matches(
      /^[a-zA-Z_][a-zA-Z0-9_]*$/,
      getRequiredI18n("onlyUseLettersNumbersAndUnderscores")
    )
    .required(getRequiredI18n(messageI18n));
};

const notRequireCode = () => {
  return Yup.string()
    .matches(
      /^[a-zA-Z_][a-zA-Z0-9_]*$/,
      getRequiredI18n("onlyUseLettersNumbersAndUnderscores")
    )
    .notRequired();
};

export {
  requireDate,
  notRequireDate,
  requireNumber,
  notRequireNumber,
  notRequireString,
  requireString,
  requireObject,
  notRequireObject,
  requireArrayObject,
  notRequireArrayObject,
  requireEmail,
  notRequireEmail,
  requiredBoolean,
  requiredDateRange,
  notRequireDateRange,
  requireCode,
  notRequireCode,
};
